module.exports = __webpack_public_path__ + "static/media/poros.41a1a2eb.jpg";